import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { NgxTolgeeModule } from '@tolgee/ngx';
import {
  NgxExtendedPdfViewerModule,
  NgxExtendedPdfViewerService,
  pdfDefaultOptions
} from 'ngx-extended-pdf-viewer';
import { emulateClick } from '../../core/a11y';

@Component({
  selector: 'app-social-environment',
  styles: ":host ::ng-deep .page { margin: 0 auto !important; }",
  providers: [ NgxExtendedPdfViewerService ],
  imports: [
    NgOptimizedImage,
    NgxTolgeeModule,
    NgxExtendedPdfViewerModule
  ],
  templateUrl: './social-environment.component.html'
})
export class SocialEnvironmentComponent {
  page: number = 1;
  protected readonly Math = Math;
  protected readonly emulateClick = emulateClick;

  constructor() {
    pdfDefaultOptions.doubleTapZoomsInHandMode = false;
  }
}
